var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b87b4beb361b199f14fbf9a656c9bc0d332d69a5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["daonative@daonative"]={id:"b87b4beb361b199f14fbf9a656c9bc0d332d69a5"};
      